import styled from '@emotion/styled';
// eslint-disable-next-line import/no-default-export
export default styled;
//# sourceMappingURL=styled.js.map